import { PaymentsCreateOrderAttributes, PaymentsProduct } from "~/api/Api";

import { Icon } from "../../../assets/icons/Icon";
import { FeatureSection } from "../featureSection/FeatureSection";
import { PricingCard } from "../pricingCard/PricingCard";
import styles from "./BrandLinksPackage.module.scss";

const text2 = [
  {
    title: "Select the right plan",
    description: `Choose the package that best fits your site and objectives. Once your order is placed, our team will begin preparing your Foundation campaign.`,
  },
  {
    title: "We build the placements",
    description: `Our team gathers the required business information from your site and uses it to create and complete Foundation profiles and listings across relevant properties. If anything additional is needed, we'll contact you directly.`,
  },
  {
    title: "Track delivery in your dashboard",
    description: `Completed placements are added to your dashboard as they are delivered. Most campaigns are completed within 60 days, and we'll notify you when your order is finished.`,
  },
];

interface BrandLinksPackageProps {
  product: PaymentsProduct;
  targetSites: { value: string; label: string }[];
  createOrder: (order: PaymentsCreateOrderAttributes) => void;
}
const descriptionList = (value: string | null) => [
  `${value} Foundation placements`,
  `Build trusted directory and profile coverage`,
  `${value} core link signals to support visibility`,
  `Strengthen baseline credibility across the web`,
  `60 Day delivery`,
];

export const BrandLinksPackage = ({
  product,
  targetSites,
  createOrder,
}: BrandLinksPackageProps) => {
  return (
    <div className={styles.brandLinksPackage}>
      {/*
       // @ts-expect-error TS2551 non-existing className */}
      <main className={styles.brandLinksPackage__main}>
        <div className={styles.brandLinksGrid}>
          {/* Foundation service description section */}
          <section className={styles.descriptionCard}>
            <div className={styles.descriptionWrapper}>
              <h3 className={styles.descriptionTitle}>
                We'll Build Your Foundation Links for You
              </h3>
              <div className={styles.descriptionContent}>
                <div className={styles.brandLinksImage}>
                  <Icon
                    iconName="BrandLinksImage1"
                    width="19.125rem"
                    height="12.5rem"
                  />
                </div>

                <div className={styles.descriptionTextContainer}>
                  <p className={styles.descriptionText}>
                    Foundation links help establish your brand across trusted
                    directories, profile pages, and web properties that support
                    long-term search visibility.
                  </p>
                  <p className={styles.descriptionText}>
                    Our team will create and optimize these placements using
                    your business information, publish them across relevant
                    sites, and track them through completion.
                  </p>
                  <p className={styles.descriptionText}>
                    This gives your site a stronger baseline of credibility
                    without adding more manual work to your team.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/*
           // @ts-expect-error TS2551 non-existing className */}
          <section className={styles.brandLinksPackage__pricing}>
            {product.prices?.map((price) => (
              <PricingCard
                key={price.id}
                price={price}
                targetSites={targetSites}
                createOrder={createOrder}
                list={descriptionList(price.size)}
              />
            ))}
          </section>
        </div>
        <FeatureSection
          icon="BrandLinksImage2"
          title="How it works"
          text={text2}
          reversed
        />
      </main>
    </div>
  );
};
